import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { ICheckoutState, initialState as checkoutInitialState, reducer as checkoutReducer } from './checkout';
import { IClientState, initialState as clientInitialState, reducer as clientReducer } from './client';
import { initialState as paymentInitialState, IPaymentState, reducer as paymentReducer } from './payment';
import { initialState as statusInitialState, IStatusState, reducer as statusReducer } from './status';
import { initialState as upsellInitialState, IUpsellState, reducer as upsellReducer } from './upsell';
import { initialState as userInitialState, IUserState, reducer as userReducer } from './user';
import { initialState as languageInitialState, ILanguageState, reducer as languageReducer } from './languages';

export interface IAppState {
    checkout: ICheckoutState;
    payment: IPaymentState;
    status: IStatusState;
    client: IClientState;
    upsell: IUpsellState;
    user: IUserState;
    language: ILanguageState;
}

const rootPersistConfig = {
    key: 'root',
    storage,
    whitelist: ['printing'],
};

const combinedReducer = combineReducers<IAppState>({
    checkout: checkoutReducer,
    client: clientReducer,
    payment: paymentReducer,
    status: statusReducer,
    upsell: upsellReducer,
    user: userReducer,
    language: languageReducer,
});

export const initialState: IAppState = {
    checkout: checkoutInitialState,
    client: clientInitialState,
    payment: paymentInitialState,
    status: statusInitialState,
    upsell: upsellInitialState,
    user: userInitialState,
    language: languageInitialState,
};

export default persistReducer(rootPersistConfig, combinedReducer);
